<script setup>
  import { defineProps, ref, computed } from 'vue'
  const props = defineProps({
    pokemon: {
      type: Object,
      default: null,
    }
  })
  const errored = ref(false)
  const basename = computed(()=>{
    if (errored.value){
      return 'unknown'
    }
    return props.pokemon?.basename ?? 'unknown'
  })
</script>
<template>
  <div
    class="w-16 h-10 bg-no-repeat bg-center"
    :title="(props.pokemon?.name ?? 'Unknown')"
    :alt="'A pixel-art icon of '+(props.pokemon?.name ?? 'a question mark')"
    :style="{
      backgroundImage: `url(images/pokemon-icons/${basename}.png)`
    }"
  ><img v-if="props.pokemon" class="hidden" :src="`images/pokemon-icons/${props.pokemon.basename}.png`" v-on:error="()=>{errored = true}"/></div>
</template>
